import { createEvent } from 'effector';

export const toggleChat = createEvent();
export const openChat = createEvent();
export const closeChat = createEvent();
